<template>
  <slide-base
    :currentSlide="currentSlide"
    :is-loading="isLoading"
    @on-next-slide="onNextSlide"
  ></slide-base>
</template>

<script>
import SlideBase from '../game/SlideBase.vue';
import useSlides from '@/composables/useSlides';

export default {
  name: 'Slide3',
  components: { SlideBase },
  setup(_, { root, emit }) {
    const { currentSlide, isLoading, onNextSlide } = useSlides(3, root, emit);

    return { currentSlide, isLoading, onNextSlide };
  },
};
</script>

<style lang="stylus" scoped></style>
